import _ from 'lodash'

var bsn = require ('bootstrap.native')

let accordionButtons = document.getElementsByClassName('accordion-button')
if (accordionButtons) {
  _.forEach(accordionButtons, button => {
    button.addEventListener('click', (e) => {
      let icons = e.currentTarget.parentElement.parentElement.getElementsByClassName('accordion-arrow')

      // remove class red on all buttons but the current target
      _.forEach(accordionButtons, button => {
        if (button != e.currentTarget) {
          button.classList.remove('text-red')
        }
      })

      // toggle arrow and red class on target
      if (icons.length) {
        e.currentTarget.classList.toggle('text-red')
        icons[0].classList.toggle('icon-pictos_site_OIP_fleche_bas')
        icons[0].classList.toggle('icon-pictos_site_OIP_fleche_haut')
      }

      // remove arrow haut on others
      _.forEach(document.getElementsByClassName('accordion-arrow'), icon => {
        if (icon != icons[0]) {
          icon.classList.remove('icon-pictos_site_OIP_fleche_haut')
          icon.classList.add('icon-pictos_site_OIP_fleche_bas')
        }
      })
    })
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/includes/fiche-droits.js